<template>
  <div>
    <a-upload
      :action="uploadAction"
      list-type="picture"
      :default-file-list="fileUrlList"
      v-if="isThumb"
    >
      <a-button> <a-icon type="upload" /> upload </a-button>
    </a-upload>

    <a-upload
      v-else
      class="avatar-uploader"
      list-type="picture-card"
      :show-upload-list="false"
      :name="name"
      :accept="accept"
      :multiple="false"
      :headers="headers"
      :action="uploadAction"
      @change="handleChange"
      :before-upload="beforeUpload"
    >
      <img v-if="imageUrl" :src="imageUrl" alt="avatar" class="avatar-img" />
      <div v-else>
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
  </div>
</template>
<script>
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  props: {
    accept: {
      type: String,
      default: '.jpg,.png,.jpeg,.bmp,.gif,.webp',
    },
    name: {
      type: String,
      default: 'file',
    },
    imgUrl: {
      type: String,
      default: '',
    },
    isThumb: {
      //多图片列表
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Array],
      required: false,
    },
    needSplit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction: '',
      fileUrlList: [],
      imageUrl: '',
      loading: false,
      imageType:
        'image/jpg,image/png,image/jpeg,image/bmp,image/gif,image/webp',
    };
  },
  created() {
    let host =
      window.location.hostname == 'localhost'
        ? process.env.VUE_APP_LOCAL_PATH +
          process.env.VUE_APP_GATEWAY_URL +
          'system-file-biz/resources/upload'
        : process.env.VUE_APP_GATEWAY_URL + 'system-file-biz/resources/upload';
    this.uploadAction = host;
  },
  watch: {
    imgUrl(val) {
      if (val instanceof Object) {
        this.imageUrl = val.fileUrl;
      } else {
        this.imageUrl = val;
      }
    },
    value(val) {
      if (this.imgUrl) {
        return;
      }
      if (val instanceof Array) {
        this.fileUrlList = val;
      } else if (val instanceof Object) {
        this.imageUrl = val.fileUrl;
      } else {
        this.imageUrl =
          this.needSplit && window.location.hostname == 'localhost'
            ? VUE_APP_LOCAL_PATH + process.env.VUE_APP_FILE_PATH + val
            : val;
      }
    },
  },
  methods: {
    handleChange(info) {
      const { file, fileList } = info;
      let status = file.status;
      if (status == 'uploading') {
        this.loading = true;
        return;
      }
      if (status == 'done') {
        let res = file.response;
        this.loading = false;
        if (res.success) {
          this.$message.success('上传成功！');
          let fileObj = {
            uid: file.uid,
            name: file.name,
            createdTime: file.lastModifiedDate,
            size: file.size,
            fileName: res.result.fileName,
            url: res.result.fileUrl,
          };
          if (this.isThumb) {
            let attachmentList = [];
            attachmentList.push(fileObj);
            index != -1 && this.fileUrlList.splice(index, 1);
            this.fileUrlList = this.fileUrlList.concat(attachmentList); //this.attachmentList;
            this.$emit('handleFileList', this.fileUrlList);
          } else {
            this.imageUrl = res.result;
            this.$emit('handleFileList', fileObj);
          }
        }
      }
    },
    beforeUpload: function (file) {
      var fileType = file.type;
      let types = this.imageType.split(',');
      let index = types.findIndex((item) => item != file.type);
      if (index < 0) {
        this.$message.error('图片格式有误!');
      }
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      }
    },
  },
};
</script>
<style soped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.avatar-img {
  width: 300px;
  height: 200px;
}
</style>
